<template>
  <v-card class="pa-6">
    <BaseDataTable
      :headers="headerTable"
      :items="info"
      :items-per-page="8"
      :currentPage="currentPage"
      :lastPage="lastPage"
      sort-by="id"
      :loading="loading"
      :paginate="true"
      :search="search"
      :footer-props="{ itemsPerPageText: 'Linhas por página' }"
      single-select
      @pageChange="fetchLogins({ ...filter, page: $event })"
      @click:row="lastClicked"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="7" lg="7" class="pa-0 d-flex align-center">
            <!-- <p class="title ma-0">Logins {{ portal.descricao }}</p> -->
          </v-col>
          <v-col cols="12" md="5" lg="5" class="d-flex align-start pa-0">
            <v-btn
              height="55px"
              dark
              class="mr-2 elevation-0"
              color="#313a46"
              v-can:permission="'logins#store'"
              @click="dialogLogins = !dialogLogins"
            >
              <v-icon small class="mr-3">mdi-plus-circle</v-icon>adicionar
            </v-btn>
            <MenuFilterSearchTable
              :placeholder="'Buscar por descrição'"
              :textQuery="'descricao'"
              :codQuery="'id'"
              @textValue="updateFilter($event)"
            />
          </v-col>
        </v-row>
      </template>
      <!-- ---------------- header ---------------- -->
      <template v-slot:header.descricao="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            @texValue="filterTable($event)"
            @clearable="clearableFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <template v-slot:header.login="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            @texValue="filterTable($event)"
            @clearable="clearableFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <!-- ---------------- items ---------------- -->
      <template v-slot:item.login="{ item }">
        <EditLogins
          @updateTableLogins="fetchLogins({ ...filter, page: currentPage })"
          :items="item"
          :portal="portal"
          label="login"
        />
      </template>

      <template v-slot:item.password="{ item }">
        <EditLogins
          @updateTableLogins="fetchLogins({ ...filter, page: currentPage })"
          :items="item"
          :portal="portal"
          label="password"
        />
      </template>

      <template v-slot:item.descricao="{ item }">
        <EditLogins
          @updateTableLogins="fetchLogins({ ...filter, page: currentPage })"
          :items="item"
          :portal="portal"
          label="descricao"
        />
      </template>

      <template v-slot:item.action="{ item }">
        <v-tooltip v-can:permission="'login-adicional#list-all'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="openModalAdditional(item)">
              <v-icon size="20" :attrs="attrs" v-on="on" color="primary"
                >mdi-lock-plus</v-icon
              >
            </v-btn>
          </template>
          Logins adicionais
        </v-tooltip>
        <v-tooltip v-can:permission="'logins#delete'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="deletePortal(item)">
              <v-icon size="20" :attrs="attrs" v-on="on" color="error"
                >mdi-trash-can</v-icon
              >
            </v-btn>
          </template>
          Apagar login
        </v-tooltip>
      </template>
    </BaseDataTable>
    <FormLogins
      @updateTableLogins="fetchLogins({ ...filter, page: currentPage })"
      :portal="portal"
      :dialog.sync="dialogLogins"
    />
    <FormLoginAdditional
      :itemLogin="additionalLogins"
      :idLogin="idLogin"
      :dialog.sync="dialogAdditional"
      @updateTableLogins="fetchLogins({ ...filter, page: currentPage })"
      @resetClick="idLogin = null"
    />
    <!-- @resetClick="additionalLogins = {}" -->
  </v-card>
</template>

<script>
import BaseDataTable from "@/components/BaseDataTable.vue";
import MenuFilter from "@/components/MenuFilter.vue";
import MenuFilterSearchTable from "@/components/MenuFilterSearchTable.vue";
import logins from "@/services/http/rpa/Logins.js";
import senhas from "@/services/http/rpa/Senhas.js";
import { permissions } from "@/store/permissionsStore";
import { handleFilter } from "@/util/handleFilter.js";
import FormLoginAdditional from "./FormLoginAditional.vue";
import FormLogins from "./FormLogins.vue";
import EditLogins from "./MenuEditLogins.vue";

import toast from "@/commom/toast";

export default {
  components: {
    BaseDataTable,
    MenuFilter,
    FormLogins,
    EditLogins,
    FormLoginAdditional,
    MenuFilterSearchTable,
  },

  data() {
    return {
      filter: {},
      portal: {},
      idPortal: null,
      info: [],
      currentPage: 1,
      lastPage: 1,
      allData: [],
      selectedRow: -1,
      search: "",
      loading: true,
      dialogLogins: false,
      dialogAdditional: false,
      additionalLogins: {},
      idLogin: 0,
    };
  },

  async created() {
    this.idPortal = this.$route.params.idPortal;
    await this.fetchPortal();
    await this.fetchLogins();
  },

  computed: {
    headerTable() {
      const permissionUser = permissions();
      let headers = [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Descrição",
          align: "center",
          sortable: true,
          value: "descricao",
          filterable: true,
        },
        {
          text: "Login",
          align: "center",
          sortable: true,
          value: "login",
          filterable: true,
        },
        {
          text: "Senha",
          align: "center",
          value: "password",
          filterable: true,
        },
      ];

      if (
        permissionUser.getPermissions["logins"].includes("delete") ||
        permissionUser.getPermissions["login-adicional"].includes("list-all")
      ) {
        headers.push({ text: "Ações", align: "center", value: "action" });
      }

      return headers;
    },
  },
  watch: {
    filter(value) {
      console.log(value);
      this.fetchLogins(value);
    },
  },
  methods: {
    clearableFilter(event) {
      delete this.filter[event];
      this.filterTable();
    },

    filterTable(event) {
      this.info = handleFilter(this.filter, this.allData, event);
    },

    updateFilter(event) {
      this.filter = { ...this.filter, ...event };
    },

    async fetchPortal() {
      try {
        this.loading = true;
        let { data } = await senhas(this.idPortal).show();
        this.portal = data;
        this.$emit("description", this.portal.descricao);
      } catch (error) {
        console.error(error);
      }
    },

    async fetchLogins(filters) {
      try {
        this.loading = true;
        let { data } = await senhas(this.idPortal).rpaloginsShow({
          ...filters,
          per_page: 8,
        });
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        this.info = data.data;
        this.allData = this.info;
        this.loading = false;
      } catch (error) {
        console.log("error", error);
      }
    },

    async deletePortal(item) {
      let res = await this.$swal({
        title: "Você tem certeza?",
        text: "Isso não pode ser desfeito",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, apagar o portal",
        cancelButtonText: "Cancelar",
      });
      if (!res.isConfirmed) return;
      try {
        await logins(item.id).delete();
        toast("success", "Login removido");
        this.fetchLogins({ ...this.filter, page: this.currentPage });
      } catch (err) {
        toast("error", "Erro inesperado");
      }
    },
    openModalAdditional(item) {
      this.idLogin = item.id;
      this.dialogAdditional = true;
      this.additionalLogins = item;
    },
    getAdditionalLogins(loginData) {
      let loginAdditional = [];
      for (var i = 0; i < Object.keys(loginData).length - 3; i++) {
        loginAdditional.push(loginData[`login${i}`]);
      }
      return loginAdditional;
    },
    lastClicked: function (item, row) {
      row.select(true);
      this.selectedRow = item.id;
    },
  },
};
</script>

<style>
tr.v-data-table__selected {
  background: #7edd83 !important;
}
</style>
